/**
 * Created by mac on 1/20/21
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    COLOR_BONUS: new cc.Color(215, 169, 255, 255),
    SHOP_STROKE_COLOR: new cc.Color(0, 0, 0, 100),
    SHOP_SHADOW_COLOR: new cc.Color(0, 0, 0, 80),
    TILE_REWARDS_COLOR: new cc.Color(9, 89, 151, 255),
    LIGHT_TEXT_COLOR: new cc.Color(255, 255, 255, 255),
    YELLOW_TEXT_COLOR: new cc.Color(247, 230, 43, 255),
    LIGHT_TEXT_STROKE_COLOR: new cc.Color(0, 0, 0, 102),

    GOLD_COLOR: new cc.Color(250, 205, 31, 255),
    DARK_PURPLE_COLOR: new cc.Color(123, 32, 131, 255),

    GREEN: new cc.Color(123, 194, 63, 255),
    COLOR_RED: new cc.Color(255, 74, 74, 255),

    DARK_TEXT_COLOR: new cc.Color(143, 46, 22, 255),
    DARK_BLUE_TEXT_COLOR: new cc.Color(29, 70, 157, 255),

    DARK_BROWN_COLOR: new cc.Color(175, 74, 25),
    DARK_BROWN_COLOR2: new cc.Color(143, 46, 22),

    RARITY_COLOR_0: new cc.Color(255, 255, 255, 255),
    RARITY_COLOR_1: new cc.Color(23, 184, 243, 255),
    RARITY_COLOR_2: new cc.Color(164, 17, 218, 255),
    RARITY_COLOR_3: new cc.Color(247, 231, 80, 255),

    LIGHT_BROWN: new cc.Color(136, 56, 0, 255),

    DARK_GRAY: new cc.Color(128, 128, 128, 255),

    LIGHT_VIOLET: new cc.Color(147, 71, 232, 255),

    DARK_BLUE: new cc.Color(28, 101, 189, 255),

    ORANGE_TEXT_COLOR: new cc.Color(248, 203, 40, 255),
    DARK_BROWN_STROKE: new cc.Color(148, 91, 56),

    LIGHT_YELLOW: new cc.Color(246, 217, 104, 255),
    SETTINGS_WINDOW_TEXT_COLOR: new cc.Color(143, 46, 22, 152),

    KINGS_CUP_COLOR: new cc.Color(143, 46, 22, 255)
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BUTTON_BOOSTER: {
        size: 34,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        shadow: undefined,
        stroke: undefined,
        name: "nostroke"
    },

    AMOUNT_BOOSTER: {
        size: 36,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        shadow: undefined,
        stroke: undefined,
        name: "nostroke"
    }
});

cleverapps.overrideStyles(cleverapps.styles.UI.Button, {
    keepRadius: true
});

[
    cleverapps.styles.UI.Button.Images.control_button,
    cleverapps.styles.UI.Button.Images.back_button
].forEach((obj) => {
    cleverapps.overrideStyles(obj, {
        SKIP_RESOLUTION: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0.1
            }
        }
    });
});

(function () {
    [
        cleverapps.styles.UI.Button.Images.button_green,
        cleverapps.styles.UI.Button.Images.button_blue,
        cleverapps.styles.UI.Button.Images.button_red,
        cleverapps.styles.UI.Button.Images.button_purple,
        cleverapps.styles.UI.Button.Images.small_button_blue,
        cleverapps.styles.UI.Button.Images.small_button_green,
        cleverapps.styles.UI.Button.Images.field_button_green,
        cleverapps.styles.UI.Button.Images.field_button_blue
    ].forEach((obj) => {
        cleverapps.overrideStyles(obj, {
            SKIP_RESOLUTION: {
                padding: {
                    left: 0.5,
                    right: 0.5,
                    top: 0.05,
                    bottom: 0.12
                }
            }
        });
    });
}());

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {

    DARK_PUPRPLE_STROKE: {
        color: cleverapps.styles.COLORS.DARK_PURPLE_COLOR,
        size: 2
    },

    TITLE_TEXT_STROKE: {
        color: new cc.Color(0, 0, 0, 77),
        size: 1
    },

    TITLE_TEXT_SHADOW: {
        color: new cc.Color(191, 66, 27, 127),
        direction: cc.size(0, -3),
        blur: 3
    },

    LIGHT_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE_COLOR,
        size: 2
    },

    LIGHT_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_SHADOW_COLOR,
        direction: cc.size(0, 1),
        blur: 0
    },

    TOURNAMENT_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.DARK_PURPLE_COLOR,
        direction: cc.size(0, -3),
        blur: 0
    },

    LIGHT_TEXT_INVERSED_SHADOW: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_SHADOW_COLOR,
        direction: cc.size(0, -3),
        blur: 0
    },

    SHOP_STROKE: {
        color: cleverapps.styles.COLORS.SHOP_STROKE_COLOR,
        size: 1
    },

    SHOP_SHADOW: {
        color: cleverapps.styles.COLORS.SHOP_SHADOW_COLOR,
        direction: cc.size(0, -2),
        blur: 3
    },

    MESSAGE_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.LIGHT_VIOLET,
        size: 3
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PLAYRIX_LEVELMASTERY_STAGE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TIMER_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    BOOSTER_BEFORE_AMOUNT_TEXT: {
        name: "default",
        size: 35,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    ROW_PLAYER_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR,
        stroke: undefined
    },

    ROW_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_BROWN_COLOR2,
        stroke: undefined
    },

    MENUBAR_TEXT: {
        name: "nostroke",
        size: 42,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    STARS_PROGRESS_BAR_TEXT: {
        name: "default",
        size: 30
    },

    RIBBON_TEXT: {
        size: 36,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    MENUBAR_TIMER_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    TILE_SHOP_OFFER_TEXT: {
        name: "default",
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        size: 45
    },

    TILE_SHOP_COINS_OFFER: {
        name: "default",
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        size: 60
    },

    SHOP_WINDOW_SMALL_TILE_TITLE: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE
    },

    SHOP_LIVES_PRODUCT_TILE_DESCRIPTION_TEXT: {
        name: "nostroke",
        size: 26,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    TILE_REWARDS: {
        size: 40,
        name: "nostroke",
        color: cleverapps.styles.COLORS.TILE_REWARDS_COLOR
    },

    TILE_REWARDS_HEADER: {
        size: 30,
        name: "nostroke",
        color: cleverapps.styles.COLORS.TILE_REWARDS_COLOR
    },

    SHOP_WINDOW_TILE_TITLE: {
        name: "default",
        size: 55,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    PRODUCT_TILE_LIMIT_TEXT: {
        name: "nostroke",
        size: 26,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    SHOP_WINDOW_LIVES_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        size: 40
    },

    TILE_SHOP_BADGE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TILE_SHOP_BADGE_STROKE
    },

    PACK_TILE_REWARDS_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    WINDOW_TITLE_TEXT: {
        size: 68,
        color: cleverapps.styles.COLORS.DARK_BROWN_COLOR,
        stroke: undefined
    },

    NOBG_WINDOW_TITLE_TEXT: {
        size: 64,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: cleverapps.styles.COLORS.LIGHT_TEXT_STROKE_COLOR,
            size: 4
        },
        shadow: undefined
    },

    WINDOW_SMALL_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    TOURNAMENT_WINDOW_TITLE: {
        size: 62,
        lineHeight: 70,
        color: cleverapps.styles.COLORS.GOLD_COLOR,
        stroke: cleverapps.styles.DECORATORS.DARK_PUPRPLE_STROKE,
        shadow: cleverapps.styles.DECORATORS.TOURNAMENT_TEXT_SHADOW
    },

    TOURNAMENT_PLAYER_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    WINDOW_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LOADING_ANIMATION_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SMALL_TEXT_ERROR: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_RED
    },

    FBCONNECT_WINDOW_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LIGHT_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    BUTTON_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    PLAY_BUTTON_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    PLAY_BUTTON_HARD_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    FORCE_MESSAGE_TEXT: {
        name: "nostroke",
        size: 45,
        color: new cc.Color(177, 82, 28, 255)
    },

    LIGHT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    DARK_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    LOADING_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    REWARDS_LIST_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SIDEBAR_ICON_TEXT: {
        name: "nostroke",
        size: 38,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    CHAT_REWARD_COUNT_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    RATE_WINDOW_TEXT: {
        name: "nostroke",
        size: 60,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    FRIEND_REQUEST_TEXT: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    DIALOGUE_PERSON_TITLE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    KNOCKOUT_WINDOW_COUNTDOWN_TEXT: {
        name: "nostroke",
        size: 70,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    COOLDOWNNODE_TIMER_TEXT: {
        name: "nostroke",
        size: 65,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    CLANS_ROW_LEADER_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SUBSCRIPTION_BUTTON_TITLE: {
        size: 22,
        color: cleverapps.styles.COLORS.COLOR_GRAY,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    SUBSCRIPTION_MAIN_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TERMS_LINK_TEXT: {
        size: 26,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TERMS_TEXT: {
        size: 22,
        color: cleverapps.styles.COLORS.COLOR_GRAY,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    VIPREWARDEDWINDOW_DESCRIPTION_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    VIPREWARDEDWINDOW_TIMER_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        size: 45
    },

    VIPREWARDEDWINDOW_NOTE_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    LEVEL_TITLE_TEXT: {
        name: "nostroke",
        size: 65,
        color: new cc.Color(48, 83, 120, 255)
    },

    LEVEL_CURRENT_TITLE_TEXT: {
        size: 40,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    LEVEL_NOT_PASSED_TITLE_TEXT: {
        name: "nostroke",
        size: 40,
        color: new cc.Color(58, 58, 58, 255)
    },

    PROLONG_BUTTON_AMOUNT_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SHOP_USER_GOLD_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    BONUSSALE_PRODUCT_REWARD: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.SHOP_STROKE,
        size: 70
    },

    BONUSBG_TITLE: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: {
            color: new cc.Color(36, 79, 251, 255),
            size: 3
        }
    },

    VICTORY_TEXT: {
        name: "nostroke",
        size: 55,
        color: cleverapps.styles.COLORS.DARK_BROWN_COLOR
    },

    BACKGROUND_NAME_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    GRAY_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.COLOR_GRAY,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    YATZY_BUTTON_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    RESULTS_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_YELLOW
    },

    RESULTS_DOUBLE_TEXT: {
        name: "nostroke",
        size: 28,
        color: cleverapps.styles.COLORS.LIGHT_YELLOW
    },

    SCORE_TEXT_SINGLE: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SCORE_TEXT_DOUBLE: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    GOAL_TEXT: {
        name: "nostroke",
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_YELLOW
    },

    LOSE_WINDOW_TEXT: {
        size: 55,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    KINGSCUP_MARKS_TEXT: {
        size: 56,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    LIGHTNING_RUSH_MARKS_TEXT: {
        size: 56,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SCORE_TEXT_VICTORY_WINDOW: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SCORE_RESULT_VICTORY_WINDOW: {
        size: 70,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    NOTIFICATION_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.DARK_BLUE
    },

    NOTIFICATION_MOBILE_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.DARK_BLUE
    },

    TOOLTIP_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: undefined
    },

    NOTIFICATION_PROGRESS_FONT: {
        size: 31,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    REWARD_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    MISSION_MAIN_TITLE_TEXT: {
        size: 78,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    MISSION_TIMER_TEXT: {
        size: 70,
        color: new cc.Color(250, 233, 204, 255),
        stroke: {
            color: new cc.Color(94, 42, 113, 255),
            size: 1
        },
        shadow: undefined
    },

    LIGHTNING_RUSH_TITLE_TEXT: {
        size: 78,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    LIGHTNING_RUSH_TIMER_TEXT: {
        size: 70,
        color: new cc.Color(250, 233, 204, 255),
        stroke: {
            color: new cc.Color(94, 42, 113, 255),
            size: 1
        },
        shadow: undefined
    },

    BACKGROUNDS_WINDOW_NAME_COMING_SOON: {
        size: 38,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            size: 1,
            color: new cc.Color(94, 88, 116, 255)
        }
    },

    GAME_MESSAGE_TEXT_VERTICAL: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    OFFER_TILE_REWARDS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        name: "nostroke"
    },

    BUTTON_GREEN_BALL_TEXT: {
        size: 36,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    MENUBAR_TEXT_DELTA: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    SETTINGS_WINDOW_NAME_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    BACKGROUNDS_WINDOW_NUMBER_TEXT: {
        name: "nostroke",
        size: 55,
        color: new cc.Color(183, 22, 5, 255)
    },

    BACKGROUNDS_WINDOW_NUMBER_TEXT_BROWN: {
        name: "nostroke",
        size: 55,
        color: new cc.Color(157, 73, 0, 255)
    },

    BACKGROUNDS_WINDOW_NAME_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BACKGROUNDS_WINDOW_NEXT_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    BACKGROUNDS_WINDOW_NAME_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.DARK_BROWN_COLOR
    },

    BACKGROUNDS_PERCENTAGE: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_BROWN_COLOR
    },

    BACKGROUNDS_TEXT: {
        name: "nostroke",
        size: 50,
        color: new cc.Color(199, 134, 102, 255)
    },

    SIMPLE_PROGRESS_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    WEEKLY_GOALS_POINTS_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.DARK_BROWN_COLOR,
        stroke: undefined
    },

    WEEKLY_GOALS_TIMER_TEXT: {
        name: "nostroke",
        size: 41,
        color: cleverapps.styles.COLORS.DARK_BROWN_COLOR,
        stroke: undefined
    },

    WEEKLY_GOALS_BAR_TEXT: {
        size: 34,
        color: new cc.Color(21, 87, 178),
        stroke: {
            color: cleverapps.styles.COLORS.WHITE,
            size: 2
        }
    },

    WEEKLY_GOALS_REWARD_TEXT: {
        name: "nostroke",
        size: 26,
        color: new cc.Color(21, 87, 178),
        stroke: {
            color: cleverapps.styles.COLORS.WHITE,
            size: 2
        }
    },

    WEEKLY_GOALS_PRIZE_TEXT: {
        name: "default",
        size: 36,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    }
});

if (cleverapps.config.features.includes("lighting_rush")) {
    cleverapps.overrideFonts(cleverapps.styles.FONTS, {
        LIGHTNING_RUSH_ROW_SCORE_TEXT: {
            name: "lightstroke",
            size: 40,
            color: cleverapps.styles.COLORS.WHITE
        },
        LIGHTNING_RUSH_ROW_PLAYER_TEXT: {
            size: 40,
            color: cleverapps.styles.COLORS.DARK_BLUE_TEXT_COLOR,
            stroke: undefined
        },
        LIGHTNING_RUSH_TEXT: {
            size: 40,
            color: cleverapps.styles.COLORS.DARK_BROWN_COLOR2,
            stroke: undefined
        }
    });
}

if (cleverapps.config.features.includes("kingscup")) {
    cleverapps.overrideStyles(cleverapps.styles.KingsCupStartWindow, {
        window: {
            padding: {
                x: 20,
                top: 50,
                bottom: 20
            }
        },
        margin: 20,
        button: {
            width: 300,
            height: 105
        },
        timer: {
            width: 320,
            height: 0,
            margin: 20,
            padding: {
                x: 10
            },
            layout: {
                x: { align: "left", dx: -20 },
                y: { align: "center" }
            },
            position: [
                { x: { align: "center" }, y: { align: "bottom", dy: -245 } },
                { x: { align: "center" }, y: { align: "bottom", dy: -242 } },
                { x: { align: "center" }, y: { align: "bottom", dy: -242 } }
            ]
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.Timer, {
    width: 320,
    height: 80,

    timer: {
        x: { align: "center", dx: 15 },
        y: { align: "center", dy: 0 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    PACKWINDOW_LABEL_STROKE: {
        color: cleverapps.styles.COLORS.BLACK,
        size: 1
    }
});

cleverapps.overrideStyles(cleverapps.styles.NotificationView, {
    mobileScale: [0.5, 0.6, 0.6],
    minWidth: 480,
    padding: {
        x: 40,
        y: 20
    },

    progress: {
        height: 37
    },

    image: {
        margin: 32
    }
});

cleverapps.overrideStyles(cleverapps.styles.PrizeBarComponent, {
    prize: {
        width: 85,
        height: 85,

        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 10 },

        tooltip: {
            size: {
                width: 280,
                height: 130
            }
        },

        maxScale: 1.4,
        flyY: 10,

        present: {
            dy: 8
        }
    },

    mark: {
        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 0 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    bg: {
        width: 290,
        height: 85,
        minWidth: 247,
        timerHeight: 115,
        padding: {
            bottom: 3
        }
    },

    icon: {
        x: 20,
        y: 5
    },

    iconText: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 10 }
        }
    },

    timer: {
        icon: undefined,
        position: {
            x: { align: "center", dx: 30 },
            y: { align: "bottom", dy: -36 }
        },

        text: {
            x: { align: "center", dx: 5 },
            y: { align: "center", dy: -6 }
        }
    },

    plusButton: {
        offset: {
            x: -22,
            y: 10
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DefaultTableStyles, {
    margin: -7,
    padding: { x: 0, y: 0 },
    innerPadding: { x: 10, y: 10 }
});

cleverapps.overrideStyles(cleverapps.styles.RowView, {
    width: 700,
    height: 123,
    minWidth: 700,
    scenePadding: [100, 250, 250],

    paddingX: 15,

    content: {
        height: 123,
        margin: 16,
        verticalMargin: 16,
        x: { align: "center" },
        y: { align: "center", dy: -2 }
    },

    place: {
        withBadge: {
            width: 100
        },

        width: 50
    },

    name: {
        height: 50,

        x: { align: "left", dx: 6 },
        y: { align: "center" }
    },

    avatar: {
        padding: {
            x: 6,
            top: 6,
            bottom: 6
        },
        verticalScale: 1
    },

    prize: {
        width: 80,
        verticalWidth: 80
    },

    score: {
        width: 140,
        verticalWidth: 140,
        height: 60,

        icon: {
            x: 10,
            y: { align: "center" }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.FriendRequestView, {
    width: 580,
    height: 230,

    processButton: {
        height: 70,
        x: 50
    },

    Avatar: {
        Margin: {
            x: 50
        }
    },

    Request: {
        width: 300
    },

    close: {
        x: 28,
        y: 12
    }
});

cleverapps.overrideStyles(cleverapps.styles.FriendRequestsWindow, {
    y: 150
});

cleverapps.overrideStyles(cleverapps.styles.LevelStartWindow, {
    padding: {
        top: 0,
        bottom: 15
    }
});

if (cleverapps.styles.BoosterBeforeView) {
    cleverapps.overrideStyles(cleverapps.styles.BoosterBeforeView, {
        textAvailable: {
            y: { align: "bottom", dy: 9 },

            bg: {
                y: { align: "bottom", dy: -15 },
                height: 70
            }
        }
    });
}

if (cleverapps.styles.BoosterBeforeAmountView) {
    cleverapps.overrideStyles(cleverapps.styles.BoosterBeforeAmountView, {
        amount: {
            y: { align: "center", dy: 2 }
        }
    });
}

if (cleverapps.styles.BoostersBeforeComponent) {
    cleverapps.overrideStyles(cleverapps.styles.BoostersBeforeComponent, {
        contentMargin: 30
    });
}

cleverapps.overrideStyles(cleverapps.styles.SelectFriendWindow, {
    withFriends: {
        height: 730
    }
});

cleverapps.overrideStyles(cleverapps.styles.ConfirmExitWindow, {
    button: {
        height: 105
    }
});

cleverapps.overrideStyles(cleverapps.styles.LoseWindow, {
    livesLeftMargin: 60,

    content: {
        margin: 60
    },

    button: {
        width: 360,
        height: 105,
        x: { align: "center" },
        y: { align: "bottom", dy: 120 }
    },

    title: {
        x: { align: "center" },
        y: { align: "top", dy: -70 }
    },

    noBackground: true,

    lose_icon: {
        x: { align: "center" },
        y: { align: "center" }
    }
});

cleverapps.overrideStyles(cleverapps.styles.RestartWindow, {
    margin: 60,

    button: {
        width: 420,
        height: 90
    }
});

if (cleverapps.styles.HeroWindow) {
    cleverapps.overrideStyles(cleverapps.styles.HeroWindow, {
        padding: {
            bottom: 70
        },

        helpBlock: {
            text: {
                width: 400
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.DialogueView, {
    widthPadding: 50,
    offsetY: 10,

    persons: {
        aboveContent: false
    },
    positions: {
        bottom: {
            y: 30
        }
    },

    text: {
        arrow: {
            y: { align: "top", dy: 36 }
        },
        padding: {
            fromWallX: 50,
            x: 50,
            y: 50
        },
        verticalPadding: {
            fromWallX: 50,
            x: 50,
            y: 45
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MinimalDialogue, {
    person: {
        margin: 30,
        fitBubbleHeight: true
    },
    targetOffset: {
        left: 15, right: 20, top: 15, bottom: 35
    },
    text: {
        arrow: {
            left: {
                x: { align: "left", dx: -19 },
                y: { align: "center", dy: 0 }
            },
            right: {
                x: { align: "right", dx: 20 },
                y: { align: "center", dy: 0 }
            }
        },

        padding: {
            top: 45,
            bottom: 45,
            left: 46,
            right: 46
        },

        verticalPadding: {
            top: 30,
            bottom: 28,
            left: 31,
            right: 31
        }
    }
});

if (cleverapps.styles.LanternWindow) {
    cleverapps.overrideStyles(cleverapps.styles.LanternWindow, {
        flashingArrows: true,
        bonuses: {
            margin: 10,
            images: {
                moves: {
                    scale: 1.0
                }
            },
            y: { align: "bottom", dy: 30 }
        },
        animation: {
            y: 80,
            scale: 0.8
        },
        text: {
            width: 668
        }
    });
}

if (cleverapps.config.features.includes("prolongation")) {
    cleverapps.overrideStyles(cleverapps.styles.ProlongationWindow, {
        window: {
            padding: {
                bottom: 40
            }
        },
        padding: {
            x: 20,
            bottom: 20
        }
    });

    cleverapps.overrideStyles(cleverapps.styles.ProlongationOfferView, {
        margin: 32,

        label: {
            showAmount: false
        },

        question: {
            width: 640,
            height: 200
        },

        button: {
            width: 350,
            height: 105
        },

        bonusLabel: {
            x: { align: "center", dx: 145 },
            y: { align: "center", dy: 73 }
        }
    });
}

if (cleverapps.styles.BackgroundsWindow) {
    cleverapps.overrideStyles(cleverapps.styles.BackgroundsWindow, {
        padding: {
            right: -58,
            left: -60
        },
        present: {
            button: {
                x: { align: "center", dx: 10 }

            }
        },

        tape: {
            x: { align: "right", dx: 31 },
            withName: {
                x: { align: "right", dx: 31 }
            },
            text: {
                y: 65
            }
        },

        item: {
            bg: {
                padding: {
                    x: 10,
                    y: 12
                }
            }
        },

        lockWithName: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        name: {
            x: { align: "center" },
            y: { align: "top", dy: -30 }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.TileBadge, {
    x: { align: "center", dx: -3 },
    y: { align: "center", dy: 3 }
});

if (cleverapps.styles.StarsProgressBar) {
    cleverapps.overrideStyles(cleverapps.styles.StarsProgressBar, {
        bar: {
            offsetX: 6,
            height: 82,
            dx: 10,
            dy: 1
        },

        barAnimation: {
            offsetX: -15
        },

        present: {
            x: { align: "right", dx: 50 },
            y: { align: "center", dy: 0 },

            tooltip: {
                width: 420,
                height: 200
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.SubscriptionButtons, {
    buttonWidth: 410,
    buttonHeight: 105
});

cleverapps.overrideStyles(cleverapps.styles.CloseButton, {
    scale: [0.7, 1, 1],

    position: [{
        x: { align: "right", dx: -16 },
        y: { align: "top", dy: -12 }
    }, {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -18 }
    }, {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -18 }
    }]
});

cleverapps.overrideStyles(cleverapps.styles.Window, {
    border: {
        scale: [0.7, 1, 1],
        top: 25,
        left: 34,
        right: 36,
        bottom: 40
    },
    padding: {
        x: 70,
        top: 70,
        bottom: 60
    },
    margin: 30,
    Background: {
        padding: {
            x: -13,
            y: 20
        }
    },
    titleMargin: 60,
    HelpButton: {
        lovesTitle: true
    },
    Footer: {
        x: { align: "center" },
        y: { align: "bottom", dy: 40 },

        margin: 20
    }
});

cleverapps.overrideStyles(cleverapps.styles.Tabs, {
    buttons: {
        width: 135,
        height: 240
    },

    attention: {
        x: { align: "left", dx: -20 },
        y: { align: "top", dy: -20 }
    },

    margin: 6
});

cleverapps.overrideStyles(cleverapps.styles.RateWindow, {
    width: 800,
    height: 400,

    text: {
        height: 400
    }
});

cleverapps.overrideStyles(cleverapps.styles.WindowTitle.Types, {
    bg_window: {
        background: {
            minWidth: 459,
            minWidthVertical: 459,
            height: 127,
            padding: {
                x: 60
            }
        },
        titleSideOffset: {
            x: 160
        },
        text: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 2 }
        },
        position: {
            y: { align: "top", anchor: false, dy: 0 }
        },
        helpButton: {
            type: cleverapps.styles.UI.Button.Images.help_button,
            x: { align: "left", dx: 20 },
            y: { align: "center", dy: -2 },
            padding: {
                x: 30
            }
        }
    },
    nobg_window: {
        scale: [0.75, 1, 1],
        fontSize: [64, 64, 64],
        background: {
            height: 154,
            minWidth: 165,
            minWidthVertical: 165,
            padding: {
                x: 55
            }
        },
        position: {
            x: { align: "center" },
            y: { align: "top", dy: -30 }
        },
        text: {
            x: { align: "center" },
            y: { align: "center", dy: 0 },
            scenePaddingX: 10
        },
        helpButton: {
            x: { align: "left", dx: 90 },
            y: { align: "center", dy: 10 },
            padding: {
                x: 14
            }
        }
    }
});

if (cleverapps.config.features.indexOf("lives") !== -1) {
    cleverapps.overrideStyles(cleverapps.styles.ExtendUnlimitedLivesWindow, {
        button: {
            width: 300,
            height: 105
        },

        animation: {
            height: 200
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.FingerView, {
    anchorX: 0.1,
    anchorY: 0.9
});

if (cleverapps.styles.EpisodeView) {
    cleverapps.overrideStyles(cleverapps.styles.EpisodeView, {
        coming_soon: {
            activities: {
                button: {
                    height: 80
                }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.UI.Tooltip, {
    SIZE: {
        short: {
            width: 230
        },
        medium: {
            width: 270
        },
        long: {
            width: 600
        }
    },

    bgPadding: 0,

    content: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 3 }
        },
        padding: {
            x: 40,
            y: 30
        }
    },

    ARROW: {
        top: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 18 }
        },
        bottom: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -18 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SettingsWindow, {
    padding: {
        top: -15,
        left: -10,
        right: -10,
        bottom: 15
    },

    user: {
        size: [{
            width: 680
        }, {
            width: 990
        }, {
            width: 990
        }]
    },

    name: {
        position: [{
            x: { align: "left", dx: 194 },
            y: { align: "center", dy: 35 }
        }, {
            x: { align: "left", dx: 220 },
            y: { align: "center", dy: 35 }
        }, {
            x: { align: "left", dx: 220 },
            y: { align: "center", dy: 35 }
        }],

        size: [{ width: 272 }, { width: 520 }, { width: 520 }],

        margin: 10
    },

    id: {
        position: [{
            x: { align: "left", dx: 194 },
            y: { align: "center", dy: -30 }
        }, {
            x: { align: "left", dx: 220 },
            y: { align: "center", dy: -30 }
        }, {
            x: { align: "left", dx: 220 },
            y: { align: "center", dy: -30 }
        }],

        size: [{ width: 420 }, { width: 720 }, { width: 720 }],

        margin: 10
    },

    avatar: {
        size: {
            width: 178,
            height: 184
        },

        position: [{
            x: { align: "left", dx: 6 },
            y: { align: "center", dy: -2 }
        }, {
            x: { align: "left", dx: 30 },
            y: { align: "center", dy: 2 }
        }, {
            x: { align: "left", dx: 30 },
            y: { align: "center", dy: 2 }
        }],

        externalPosition: undefined,

        padding: {
            x: 14,
            top: 14,
            bottom: 14
        }
    },

    text: {
        width: [270, 560, 560]
    },

    button: {
        width: 468,
        height: 105,

        icon: {
            width: 90
        },

        margin: 10,

        text: {
            width: 300,
            height: 60
        },

        padding: {
            right: 30
        }
    },

    controlButton: {
        margin: 10,

        width: 120,
        height: 105
    },

    loginButton: {
        height: 105,
        width: 563
    },

    invite: {
        width: 131,
        height: 83
    }
});

cleverapps.overrideStyles(cleverapps.styles.LanguageButton, {
    width: 420,
    height: 105
});

cleverapps.overrideStyles(cleverapps.styles.AboutWindow, {
    button: {
        height: 105
    }
});

cleverapps.overrideStyles(cleverapps.styles.DeleteAccountWindow, {
    buttons: {
        height: 105
    },
    window: {
        padding: {
            left: 50,
            right: 50,
            top: 60,
            bottom: 70
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DialoguePersonTitleView, {
    mobileY: { align: "top", anchor: "center", dy: -10 },
    text: {
        padding: {
            x: 38,
            y: -20
        },
        offset: { y: 3 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.RewardsListComponent, {
    margin: {
        x: 120,
        y: 30
    },

    content: {
        position: {
            x: { align: "center", dx: -5 },
            y: { align: "center", dy: 0 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.Exclamations, {
    rotation: -8
});

cleverapps.overrideStyles(cleverapps.styles.UI.ImageFont, {
    offset: 1,
    fixedNumberWidth: {
        stretch: 0.8
    },
    SKIP_RESOLUTION: {
        DESCENTS: {
            "fonts/balsamiq": 0.14,
            "fonts/balsamiq-lightstroke": 0.025,
            "fonts/balsamiq-nostroke": 0
        }
    },
    lettersOffset: {
        "fonts/balsamiq": -12,
        "fonts/balsamiq-lightstroke": -12,
        "fonts/balsamiq-nostroke": -14
    }
});

if (cleverapps.config.features.includes("playbutton")) {
    cleverapps.overrideStyles(cleverapps.styles.PlayButtonView, {
        width: 315,
        height: 110,
        margin: -8,
        padding: {
            bottom: 8
        },

        button: {
            SKIP_RESOLUTION: {
                padding: {
                    left: 0.5,
                    right: 0.5,
                    top: 0.15,
                    bottom: 0.15
                }
            }
        },

        position: [
            { x: { align: "center" }, y: { align: "bottom", dy: 175 } },
            { x: { align: "center" }, y: { align: "bottom", dy: 175 } },
            { x: { align: "center" }, y: { align: "bottom", dy: 175 } }
        ]
    });
}

cleverapps.overrideStyles(cleverapps.styles.SignInWindow, {
    button: {
        width: 500,
        height: 105
    }
});

cleverapps.overrideStyles(cleverapps.styles.VictoryMessageContentView, {
    text: {
        position: [{
            x: { align: "center", dx: 90 },
            y: { align: "center" }
        }, {
            x: { align: "center" },
            y: { align: "center" }
        }, {
            x: { align: "center" },
            y: { align: "center" }
        }]
    },

    animation: {
        position: [{
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 12 }
        }, {
            x: { align: "center", dx: -50 },
            y: { align: "center", dy: 52 }
        }, {
            x: { align: "center", dx: -50 },
            y: { align: "center", dy: 52 }
        }]
    }
});

cleverapps.overrideStyles(cleverapps.styles.TreasureBag, {
    background: false
});

if (cleverapps.styles.SuppliesWindow) {
    cleverapps.overrideStyles(cleverapps.styles.SuppliesWindow, {
        window: {
            padding: [
                {
                    left: 40,
                    right: 40,
                    top: 40,
                    bottom: 40
                },
                {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            ]
        },
        scales: [0.8, 1, 1]
    });
}

if (cleverapps.styles.CrossPromoWindow) {
    cleverapps.overrideStyles(cleverapps.styles.CrossPromoWindow, {
        window: {
            border: {
                top: 60
            }
        },

        scrollView: {
            width: 1220,
            height: [700, 700, 700],
            mobileHorizontalHeight: 700
        }
    });
}

if (cleverapps.config.features.includes("editprofile")) {
    cleverapps.overrideStyles(cleverapps.styles.ProfileWindow, {
        nameGenerator: {
            button: {
                width: 120,
                height: 80
            }
        }
    });
}

if (cleverapps.styles.LightningRushMarksView) {
    cleverapps.overrideStyles(cleverapps.styles.LightningRushMarksView, {
        disabled: true
    });
}

cleverapps.styles.BoosterButtonView = {
    contentOff: true,
    width: 165,
    height: 165,

    hoverHighlight: {
        width: 190,
        offset: { x: -2, y: 2 }
    },

    scale: [0.7, 0.9, 1],

    content: {
        margin: 10,
        direction: cleverapps.UI.VERTICAL,
        iconSlot: {
            width: 112,
            height: 112
        },
        layout: {
            x: { align: "center" },
            y: { align: "center", dy: 30 }
        },
        freeBlock: {
            textWidth: 105
        }
    }
};

cleverapps.overrideStyles(cleverapps.styles.LoadingAnimation, {
    animation: {
        verticalScale: 0.85
    }
});

// Balsamiq sits high in its box; every playrix game had to nudge the button label down.
cleverapps.overrideStyles(cleverapps.styles.RestoreProgressButton, {
    content: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 7 }
    }
});
